import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import CustomerModule from './modules/customer'
import { getModule } from 'vuex-module-decorators'
import { currentShop } from '@/utils/shop'

// Все витрины общего домена делят один localStorage, а состояние лежало под
// одним ключом на всех. Поэтому при переходе из магазина в магазин корзина и
// данные оформления прошлого приезжали в следующий, а сохранённый retailerPage
// успевал нарисовать чужое название, тексты и цвета до ответа API.
const vuexLocal = new VuexPersistence({
  key: `vuex:${currentShop()}`,
  storage: window.localStorage,
});

// Общий ключ прежних версий: чужие корзины в нём уже не читаются, но лежали бы
// вечно. В приватном режиме и при запрещённых куках обращение кидает — молча.
try {
  window.localStorage.removeItem('vuex')
} catch (e) {
  // игнорируем: без localStorage витрина работает, просто ничего не помнит
}

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    customer: CustomerModule
  },
  plugins: [vuexLocal.plugin]
})

export default store
export const customer = getModule(CustomerModule, store)
